
import React from 'react';
import PropTypes from 'prop-types';
// components
import { Card, CardActions, CardText, CardHeader } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';
import Total from '../Display/Total';
import AssignmentIcon from 'material-ui/svg-icons/action/assignment-ind';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import BasicProgressBar from '../ProgressBar/BasicProgressBar';
import { capitalise } from '../../utils/StringUtils';

const progressSection = (label, data, link='/dashboard/courses/enrolments/stats/group/course') => {
    let displayFlag = null;
    if (label === 'optional' || label === 'mandatory' ) {
        displayFlag =  <SpotIcon className="icon-small" color={statusColours[label]} key={label}/>;
    }

    return (
        <div key={label}>
            <BasicProgressBar {...data} link={link} />
            <p className="progressBar-label">
                {displayFlag}
                {capitalise(label)} {data.completed}/{data.total} {!!data.waiting && `(${data.waiting} waiting)`}</p>
        </div>
    );
};

const parseStats = (rawData) => {
    if (!rawData || rawData.length === 0) { return {}; } // guard: empty
    const enrolmentData = {
        mandatory: {
            completed: 0,
            enrolled: 0,
            waiting: 0,
            total: 0,
        },
        optional: {
            completed: 0,
            enrolled: 0,
            waiting: 0,
            total: 0,
        },
        total: 0,
    };

    rawData.forEach(({status, assignments, isMandatory}) => {
        const num = Number(assignments);
        if (!num) { return; }

        enrolmentData.total += num;
        const section = isMandatory ? 'mandatory' : 'optional';
        enrolmentData[section].total += num;
        if (enrolmentData[section][status] !== undefined) {
            enrolmentData[section][status] += num;
        }
    });
    return enrolmentData;
};

const sections = ['mandatory', 'optional'];
const StaffTrainingWidget = ({subtitle, enrolments, cardActions}) => {
    const data = parseStats(enrolments);
    return (
        <div className="cent-flex-row">
            <Card className="cent-card" initiallyExpanded={true}>
                <CardHeader
                    title="Staff progress"
                    subtitle={subtitle}
                    avatar={<AssignmentIcon color={statusColours.default} />}
                />
                <CardText className="cent-zero">
                    <div className="cent-content">
                        <div className="content-left">
                            <a className="a-block" href={`/dashboard/courses/enrolments/stats/group/course`}>
                                <Total
                                    key="score"
                                    amount={data.total}
                                    symbol=''
                                    title='Assignments'
                                    link={`/dashboard/courses/enrolments/stats/group/course`}
                                />
                            </a>
                        </div>
                        <div className="content-main">
                            {sections
                                .filter(section => (data[section] && data[section].total))
                                .map(section => progressSection(section, data[section]))
                            }
                        </div>
                    </div>
                </CardText>
                {(!!cardActions && cardActions.length > 0) && (
                        <CardActions>{cardActions}</CardActions>
                )}
            </Card>
        </div>
    );

};

StaffTrainingWidget.propTypes = {
    subtitle:       PropTypes.string.isRequired,
    enrolments:     PropTypes.array.isRequired,
    cardActions:    PropTypes.array,
};

export default StaffTrainingWidget;
